<template>
  <el-dialog
    class="preview-dialog"
    title="预览"
    :visible.sync="dialogVisible"
    width="402px"
    :before-close="handleClose"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="preview">
      <div class="info">
        <div class="school">
          <div class="logo" v-if="schoolInfo.logUrl">
            <img
              class="img"
              :src="$store.state.config.fileUrl + schoolInfo.logUrl"
              alt=""
            />
          </div>
          <div class="name">{{ schoolInfo.schoolName }}</div>
        </div>
        <div class="card-title">{{ detail.headerName }}</div>
        <div class="li li-1">
          <div class="li-left">风险点名称</div>
          <div class="li-right">{{ detail.post }}</div>
        </div>
        <div class="li li-2">
          <div class="li-left">风险因素</div>
          <div class="li-right">{{ detail.mainRiskFactors }}</div>
        </div>
        <div class="li li-3">
          <div class="li-left">风险类别</div>
          <div class="li-right">{{ detail.typesAccidents }}</div>
        </div>
        <div class="li li-4">
          <div class="li-top">管 控 措 施</div>
          <div class="li-bottom">{{ detail.controlMeasures }}</div>
        </div>
        <div class="li li-5">
          <div class="li-top">应 急 措 施</div>
          <div class="li-bottom">{{ detail.emergencyMeasures }}</div>
        </div>
        <div class="li li-6">
          <div class="li-left">责任人</div>
          <div class="li-right">联系电话</div>
        </div>
        <div class="li li-6">
          <div class="li-left">{{ personFirst.name }}</div>
          <div class="li-right">{{ personFirst.phone }}</div>
        </div>
        <div class="li li-6">
          <div class="li-left">{{ personSecond.name }}</div>
          <div class="li-right">{{ personSecond.phone }}</div>
        </div>
        <div class="li warn-icon">
          <img
            class="img"
            v-show="checked1"
            src="@/assets/img/noticeTemplates/new/1.jpg"
            alt=""
          />
          <img
            class="img"
            v-show="checked2"
            src="@/assets/img/noticeTemplates/new/2.png"
            alt=""
          />
          <img
            class="img"
            v-show="checked3"
            src="@/assets/img/noticeTemplates/new/3.png"
            alt=""
          />
          <img
            class="img"
            v-show="checked4"
            src="@/assets/img/noticeTemplates/new/4.png"
            alt=""
          />
          <img
            class="img"
            v-show="checked5"
            src="@/assets/img/noticeTemplates/new/5.png"
            alt=""
          />
          <img
            class="img"
            v-show="checked6"
            src="@/assets/img/noticeTemplates/new/6.png"
            alt=""
          />
          <img
            class="img"
            v-show="checked7"
            src="@/assets/img/noticeTemplates/new/7.png"
            alt=""
          />
          <img
            class="img"
            v-show="checked8"
            src="@/assets/img/noticeTemplates/new/8.png"
            alt=""
          />
            <img
              class="img"
              v-show="checked9"
              src="@/assets/img/noticeTemplates/new/9.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked10"
              src="@/assets/img/noticeTemplates/new/10.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked11"
              src="@/assets/img/noticeTemplates/new/11.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked12"
              src="@/assets/img/noticeTemplates/new/12.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked13"
              src="@/assets/img/noticeTemplates/new/13.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked14"
              src="@/assets/img/noticeTemplates/new/14.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked15"
              src="@/assets/img/noticeTemplates/new/15.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked15"
              src="@/assets/img/noticeTemplates/new/16.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked17"
              src="@/assets/img/noticeTemplates/new/17.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked18"
              src="@/assets/img/noticeTemplates/new/18.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked19"
              src="@/assets/img/noticeTemplates/new/19.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked20"
              src="@/assets/img/noticeTemplates/new/20.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked21"
              src="@/assets/img/noticeTemplates/new/21.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked22"
              src="@/assets/img/noticeTemplates/new/22.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked23"
              src="@/assets/img/noticeTemplates/new/23.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked24"
              src="@/assets/img/noticeTemplates/new/24.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked25"
              src="@/assets/img/noticeTemplates/new/25.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked26"
              src="@/assets/img/noticeTemplates/new/26.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked27"
              src="@/assets/img/noticeTemplates/new/27.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked28"
              src="@/assets/img/noticeTemplates/new/28.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked29"
              src="@/assets/img/noticeTemplates/new/29.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked30"
              src="@/assets/img/noticeTemplates/new/30.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked31"
              src="@/assets/img/noticeTemplates/new/31.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked32"
              src="@/assets/img/noticeTemplates/new/32.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked33"
              src="@/assets/img/noticeTemplates/new/33.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked34"
              src="@/assets/img/noticeTemplates/new/34.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked35"
              src="@/assets/img/noticeTemplates/new/35.png"
              alt=""
            />
            <img
              class="img"
              v-show="checked36"
              src="@/assets/img/noticeTemplates/new/36.png"
              alt=""
            />
        </div>
        <div class="li li-7">
          <div class="li-left">紧急电话</div>
          <div class="li-right">{{ detail.emergencyCall }}</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "RiskNoticeTemplateOperate",
  components: {},
  props: {
    previewResize: {
      type: Number,
      default: {
        return: 0
      }
    },
    detail: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      direction: "ltr",
      schoolName: this.$store.state.schoolInfo.schoolName,
      personFirst: {
        name: "",
        phone: ""
      },
      personSecond: {
        name: "",
        phone: ""
      },
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      checked5: false,
      checked6: false,
      checked7: false,
      checked8: false,
      checked9: false,
      checked10: false,
      checked11: false,
      checked12: false,
      checked13: false,
      checked14: false,
      checked15: false,
      checked16: false,
      checked17: false,
      checked18: false,
      checked19: false,
      checked20: false,
      checked21: false,
      checked22: false,
      checked23: false,
      checked24: false,
      checked25: false,
      checked26: false,
      checked27: false,
      checked28: false,
      checked29: false,
      checked30: false,
      checked31: false,
      checked32: false,
      checked33: false,
      checked34: false,
      checked35: false,
      checked36: false
    };
  },
  created() {},
  mounted() {},
  watch: {
    previewResize: function(newVal, oldVal) {
      if (newVal) {
        this.dialogVisible = true;
        this.modify(this.detail.warningIcon);
        this.modifyPerson(this.detail.responsible);
        // console.log(this.detail);
        // console.log(this.$store.state.schoolInfo);
      }
    }
  },
  computed: {
    schoolInfo() {
      return this.$store.state.schoolInfo;
    }
  },
  methods: {
    handleClose() {
      this.resizeCheck();
      this.dialogVisible = false;
    },
    resizeCheck() {
      this.checked1 = false;
      this.checked2 = false;
      this.checked3 = false;
      this.checked4 = false;
      this.checked5 = false;
      this.checked6 = false;
      this.checked7 = false;
      this.checked8 = false;
      this.checked9 = false;
      this.checked10 = false;
      this.checked11 = false;
      this.checked12 = false;
      this.checked13 = false;
      this.checked14 = false;
      this.checked15 = false;
      this.checked16 = false;
      this.checked17 = false;
      this.checked18 = false;
      this.checked19 = false;
      this.checked20 = false;
      this.checked21 = false;
      this.checked22 = false;
      this.checked23 = false;
      this.checked24 = false;
      this.checked25 = false;
      this.checked26 = false;
      this.checked27 = false;
      this.checked28 = false;
      this.checked29 = false;
      this.checked30 = false;
      this.checked31 = false;
      this.checked32 = false;
      this.checked33 = false;
      this.checked34 = false;
      this.checked35 = false;
      this.checked36 = false;
    },
    modify(str) {
      let arr = this.strToArray(str);
      // console.log(arr);
      if (this.check("1", arr)) {
        this.checked1 = true;
      }
      if (this.check("2", arr)) {
        this.checked2 = true;
      }
      if (this.check("3", arr)) {
        this.checked3 = true;
      }
      if (this.check("4", arr)) {
        this.checked4 = true;
      }
      if (this.check("5", arr)) {
        this.checked5 = true;
      }
      if (this.check("6", arr)) {
        this.checked6 = true;
      }
      if (this.check("7", arr)) {
        this.checked7 = true;
      }
      if (this.check("8", arr)) {
        this.checked8 = true;
      }
      if (this.check("9", arr)) {
        this.checked9 = true;
      }
      if (this.check("10", arr)) {
        this.checked10 = true;
      }
      if (this.check("11", arr)) {
        this.checked11 = true;
      }
      if (this.check("12", arr)) {
        this.checked12 = true;
      }
      if (this.check("13", arr)) {
        this.checked13 = true;
      }
      if (this.check("14", arr)) {
        this.checked14 = true;
      }
      if (this.check("15", arr)) {
        this.checked15 = true;
      }
      if (this.check("16", arr)) {
        this.checked16 = true;
      }
      if (this.check("17", arr)) {
        this.checked17 = true;
      }
      if (this.check("18", arr)) {
        this.checked18 = true;
      }
      if (this.check("19", arr)) {
        this.checked19 = true;
      }
      if (this.check("20", arr)) {
        this.checked20 = true;
      }
      if (this.check("21", arr)) {
        this.checked21 = true;
      }
      if (this.check("22", arr)) {
        this.checked22 = true;
      }
      if (this.check("23", arr)) {
        this.checked23 = true;
      }
      if (this.check("24", arr)) {
        this.checked24 = true;
      }
      if (this.check("25", arr)) {
        this.checked25 = true;
      }
      if (this.check("26", arr)) {
        this.checked26 = true;
      }
      if (this.check("27", arr)) {
        this.checked27 = true;
      }
      if (this.check("28", arr)) {
        this.checked28 = true;
      }
      if (this.check("29", arr)) {
        this.checked29 = true;
      }
      if (this.check("30", arr)) {
        this.checked30 = true;
      }
      if (this.check("31", arr)) {
        this.checked31 = true;
      }
      if (this.check("32", arr)) {
        this.checked32 = true;
      }
      if (this.check("33", arr)) {
        this.checked33 = true;
      }
      if (this.check("34", arr)) {
        this.checked34 = true;
      }
      if (this.check("35", arr)) {
        this.checked35 = true;
      }
      if (this.check("36", arr)) {
        this.checked36 = true;
      }
    },
    strToArray(str) {
      // console.log(str)

      var arr = str.split(",");
      // console.log(arr);
      return arr;
    },
    // 检查是否在数组中
    check(num, arr) {
      if (arr.includes(num)) {
        return true;
      } else {
        return false;
      }
    },
    modifyPerson(str) {
      // console.log(str)
      if (!str) {
        this.personFirst = {
          name: "",
          phone: ""
        };
        this.personSecond = {
          name: "",
          phone: ""
        };
      } else {
        let arr = str.split(",");
        // console.log(arr)
        this.personFirst = {
          name: arr[0],
          phone: arr[1]
        };
        this.personSecond = {
          name: arr[2],
          phone: arr[3]
        };
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.preview-dialog {
  /deep/ .el-dialog__body {
    padding: 0;
  }
}
.preview {
  width: 402px;
  height: 580px;
  .info {
    width: 402px;
    height: 580px;
    background-image: url("~@/assets/img/noticeTemplates/bg-2.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .school {
      padding: 8px 20px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .logo {
        width: 45px;
        height: 45px;
        border-radius: 50%;
        .img {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .name {
        height: 45px;
        line-height: 45px;
        padding-left: 16px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #1c1c1c;
      }
    }
    .card-title {
      margin: 26px auto 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 356px;
      height: 24px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #1c1c1c;
      word-break: break-all;
      overflow: scroll;
    }
    .li {
      padding: 0 20px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      &.li-1 {
        margin-top: 1px;
        height: 24px;
        text-align: center;
        line-height: 24px;
        .li-left {
          height: 100%;
          width: 74px;
        }
        .li-right {
          height: 100%;
          width: 290px;
          word-break: break-all;
          overflow: scroll;
        }
      }
      &.li-2 {
        margin-top: 1px;
        height: 24px;
        text-align: center;
        line-height: 24px;
        .li-left {
          height: 100%;
          width: 74px;
        }
        .li-right {
          height: 100%;
          width: 290px;
          word-break: break-all;
          overflow: scroll;
        }
      }
      &.li-3 {
        margin-top: 1px;
        height: 24px;
        text-align: center;
        line-height: 24px;
        .li-left {
          width: 74px;
          height: 100%;
        }
        .li-right {
          height: 100%;
          width: 290px;
          word-break: break-all;
          overflow: scroll;
        }
      }
      &.li-4 {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        .li-top {
          width: 362px;
          height: 22px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .li-bottom {
          width: 362px;
          height: 78px;
          padding: 2px;
          word-break: break-all;
          overflow: scroll;
        }
      }
      &.li-5 {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        .li-top {
          width: 362px;
          height: 22px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .li-bottom {
          width: 362px;
          height: 84px;
          padding: 2px;
          word-break: break-all;
          overflow: scroll;
        }
      }
      &.li-6 {
        margin-top: 1px;
        height: 24px;
        text-align: center;
        line-height: 24px;
        .li-left {
          width: 148px;
          height: 100%;
        }
        .li-right {
          height: 100%;
          width: 230px;
          word-break: break-all;
          overflow: scroll;
        }
      }
      &.li-7 {
        height: 24px;
        text-align: center;
        line-height: 24px;
        .li-left {
          height: 100%;
          width: 74px;
        }
        .li-right {
          height: 100%;
          width: 290px;
          word-break: break-all;
          overflow: scroll;
        }
      }
    }
    .warn-icon {
      width: 402px;
      height: 72px;
      display: flex;
      justify-content: center;
      align-items: center;
      .img {
        margin: 0 2px;
        width: 40.6px;
        height: 50px;
      }
    }
  }
}
</style>
